<div class="content">
	<div class="content-wrap">
		<div class="content-header margin-bottom-20px">
			<h2>Upload File</h2>
		</div>
		<div class="content-filter margin-bottom-20px">
			<div class="dropdown-container" *ngIf="awsBucketRegionConfigured">
				<div>
					<span class="label">Corporation</span>
					<div class="dd-filter">
						<select class="dropdown-width" required name="corporationSelection" id="corporationDropDown" (change)="onCorporationSelected()" [(ngModel)]="selectedCorporation">
							<option [ngValue]="null"  disabled >Select</option>
							<option *ngFor="let corporation of activeCorporations" [ngValue]="corporation">
								{{ corporation.name }}
							</option>
						</select>
					</div>
				</div>
			</div>
			<div class="dropdown-container" *ngIf="awsBucketRegionConfigured && selectedCorporation">
				<div>
					<span class="label">Client</span>
					<div class="dd-filter">
						<select class="dropdown-width" required name="clientSelection" id="clientDropDown" (change)="onClientSelected()" [(ngModel)]="selectedClient">
							<option [ngValue]="null"  disabled>Select</option>
							<option *ngFor="let client of filteredClients" [ngValue]="client">
								{{ client.name }}
							</option>
						</select>
					</div>
				</div>
				<div *ngIf="selectedClient" class="margin-left-20px">
					<span class="label">Application</span>
					<div class="dd-filter">

						<select class="small-dropdown-width" required name="applicationSelection" id="applicationDropDown" (change)="onApplicationSelected()" [(ngModel)]="selectedApplication">
							<option [ngValue]="null"  disabled>Select</option>
							<option *ngFor="let application of clientApplications" [ngValue]="application">
								{{ application.applicationName }}
							</option>
						</select>

					</div>
				</div>
				<div *ngIf="selectedApplication" class="margin-left-20px">
					<span class="label">File</span>
					<div class="dd-filter display-inline-block">

						<input type="text" id="fileName" tabindex="-1" [value]="fileName">
						<input class="d-none" type="file" id="fileUpload" size="20" [accept]="acceptedFileExtensions()" (click)="fileUploadError=''" (change)="selectFile($event)">

					</div>
					<div class="dd-filter browse-button-container">
						<button class="btn-light " id="browse-button" (click)="browseFile()" [disabled]="browseDisabled"> Browse </button>

					</div>
					<div class="validation-error" *ngIf="fileUploadError">
						{{fileUploadError}}
					</div>
				</div>
			</div>
			<div class="button-grp">
				<button class="{{getImportButtonStatus()}} import-button" type="button" id="import-button" (click)="importFile()" [disabled]="isImportButtonDisabled()">Import</button>
				<label class="import-message">{{ importMessage }}</label>
			</div>
		</div>
		<div class="content-header import-summary-heading">
			<h2>Import Summary</h2>
		</div>
		<div class="content-inner">

			<dx-data-grid #fileImportsGrid id="fileImportsGrid"
										(onContentReady)="setTableHeaderStyle()"
										(onOptionChanged)="onOptionChanged($event)"
										[remoteOperations]="true"
										[dataSource]="fileImportDataSource"
										[showColumnLines]="false"
										[wordWrapEnabled]="true"
										[columnAutoWidth]="false"
										[repaintChangesOnly]="true"
										[allowColumnResizing]="true"
										[columnAutoWidth]="true"
										[focusedRowEnabled]="true"
										(onRowClick)="onRowClick($event)"
										[columnHidingEnabled]="true"
										[noDataText]="'Sorry, no file imports were found that matched your search.'">
				<dxo-header-filter [visible]="true"></dxo-header-filter>
				<dxo-filter-row [visible]="true"></dxo-filter-row>
				<dxo-paging [pageSize]="25"></dxo-paging>
				<dxo-pager [showPageSizeSelector]="true" [visible]="true" [allowedPageSizes]="[25, 50, 100]" [showInfo]="true"></dxo-pager>

				<dxi-column dataField="status" caption="Status" [allowFiltering]="true" cellTemplate="statusIconTemplate">
					<dxo-lookup [dataSource]="statusList"
											valueExpr="id"
											displayExpr="name">
					</dxo-lookup>					
				</dxi-column>
				<dxi-column dataField="applicationId" caption="Application" [allowHeaderFiltering]="true">
					<dxo-lookup [dataSource]="allApplications"
											valueExpr="id"
											displayExpr="name">
					</dxo-lookup>
				</dxi-column>
				<dxi-column dataField="clientId" caption="Client" [allowHeaderFiltering]="true">
					<dxo-lookup [dataSource]="filteredClients"
											valueExpr="id"
											displayExpr="name">
					</dxo-lookup>
				</dxi-column>
				<dxi-column dataField="originalFileName" caption="File Name" dataType="string" [allowHeaderFiltering]="false"></dxi-column>
				<dxi-column dataField="receivedDateTime" caption="Received" dataType="date" format='MM/dd/yyyy h:mm:ss a' [allowHeaderFiltering]="true" sortOrder="desc"></dxi-column>
				<dxi-column dataField="processingStartDateTime" caption="Processing Start" dataType="date" format='MM/dd/yyyy h:mm:ss a' [allowHeaderFiltering]="true"></dxi-column>
				<dxi-column dataField="processingEndDateTime" caption="Completed" dataType="date" format='MM/dd/yyyy h:mm:ss a' [allowHeaderFiltering]="true"></dxi-column>
				<dxi-column caption="Processing Time" [calculateCellValue]="calculateProcessingTime"></dxi-column>
				<dxi-column dataField="recordCount" caption="Record Count" dataType="string" [allowSorting]="true" [allowHeaderFiltering]="false"></dxi-column>

				<div *dxTemplate="let data of 'statusIconTemplate'" class="status">
					<span class="material-symbols-outlined nav-icon" [class]="getStatusClass(data.data.status)" title="{{getStatusText(data.data.status)}}">{{getStatusIcon(data.data.status)}}</span>
				</div>
			</dx-data-grid>
			<hhsg-shared-modal 
					[isActive]="showDetailsModal"
                   (rejectEvent)="closeModal()"
                   [disableFooter]="true"
                   [disableHeader]="false">
				<div role="header">
					File Import Details
				</div>
				<div role="body" [class.loading]="loadingDetailsList">
					<div class="dx-datagrid-summary-item">Unique Filename: {{selectedFileImport?.fileName}}</div>
					<div class="dx-datagrid-modal-grid">
						<dx-data-grid #fileImportDetailsGrid
													id="fileImportDetailsGrid"
													[dataSource]="fileImportDetailsDataSource" [showColumnLines]="false"
													[masterDetail]="{ enabled: false, template: 'detail' }"
													(onContentReady)="setModalTableHeaderStyle()"
													(onRowClick)="detailRowClicked($event)"
													[focusedRowEnabled]="true" [columnHidingEnabled]="true">
							<dxo-selection mode="single"></dxo-selection>
							<dxo-paging [pageSize]="25"></dxo-paging>
							<dxo-pager [showPageSizeSelector]="true" [visible]="true" [allowedPageSizes]="[25, 50, 100]" [showInfo]="true">
							</dxo-pager>
							<dxo-header-filter [visible]="false"></dxo-header-filter>
							<dxo-filter-row [visible]="false"></dxo-filter-row>
							<dxi-column dataField="" caption="" cellTemplate="chevronIconTemplate" [width]="40">
							</dxi-column>
							<dxi-column dataField="id" caption="" [allowFiltering]="false" cellTemplate="expandRowTemplate" [width]="20"></dxi-column>
							<dxi-column dataField="lineNumber" caption="Line Number" [width]="125" sortOrder="asc"></dxi-column>
							<dxi-column dataField="messageDateTime" caption="Date" dataType="date" format='yyyy/MM/dd h:mm:ss a' [allowHeaderFiltering]="true" [width]="200"></dxi-column>
							<dxi-column dataField="friendlyMessage" caption="Message" dataType="string"></dxi-column>
							<dxi-column dataField="detailedMessage" caption="Details" dataType="string"></dxi-column>

							<div *dxTemplate="let data of 'expandRowTemplate'" class="expand">
								<span class="icon-expand-vertical"></span>
							</div>

							<div class="detail-message" *dxTemplate="let fileImportDetail of 'detail'" (click)="detailDataClicked($event)">
								<h3>Message</h3> <p class="pre-wrap">{{fileImportDetail.data.friendlyMessage}}</p>
								<h3>Details</h3> <p class="pre-wrap">{{fileImportDetail.data.detailedMessage}}</p>
							</div>
							<div *dxTemplate="let data of 'chevronIconTemplate'">
								<span class="material-symbols-outlined">
									navigate_next
								</span>
							</div>
						</dx-data-grid>
					</div>
				</div>
				<div role="footer">
					<div class="button-grp">
					  <button class="btn-primary" (click)="closeModal()">Close</button>
					</div>
				</div>
			</hhsg-shared-modal>
		</div>
	</div>
</div>
